export const START_PAGE_NUMBER = 0;
export const END_PAGE_NUMBER = 2;
export const PER_PAGE_HOT_QUESTION_NUMBER = 3;
export const PER_AUTO_PLAY_DURATION = 2000;
export const ANIMATION_DELAY = 2000;
export const ANIMATION_TRANSITION = '0.3s';
export const validSwipe = 5;
export const MAX_HOT_QUESTION_NUMBER = 9;
export const MAX_TURN_PAGES = 1;
export const INERTIAL_SLIDE_DURATION_THRESHOLD = 300;
export const INERTIAL_SLIDE_DISTANCE_THRESHOLD = 15;
export const INERTIAL_SLIDE_ACCELERATION = 0.003;
export const PER_PAGE_HOT_QUESTION_NUMBER_4 = 4;
export const PER_PAGE_HOT_QUESTION_NUMBER_5 = 5;
export const TOTAL_PAGE_NUMBER = 3;
